import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, Users, Package, LogOut, ShieldCheck, ClipboardList, Sparkles } from "lucide-react";
import { useAdmin } from "@/lib/admin";
import { Button } from "@/components/ui/button";

export default function AdminLayout({ children }) {
  const { logout } = useAdmin();
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-background flex">
      {/* Sidebar */}
      <aside className="w-60 bg-secondary text-secondary-foreground flex flex-col p-4 sticky top-0 h-screen">
        <div className="flex items-center gap-2 mb-8 px-2">
          <span className="w-9 h-9 rounded-lg bg-primary grid place-items-center">
            <ShieldCheck size={16} />
          </span>
          <div>
            <div className="font-heading font-bold text-sm">StitchQuote</div>
            <div className="text-[9px] uppercase tracking-widest opacity-70">Admin</div>
          </div>
        </div>
        <nav className="flex-1 space-y-1">
          <Item to="/admin" icon={<LayoutDashboard size={16} />} label="Dashboard" end testId="admin-nav-dashboard" />
          <Item to="/admin/factories" icon={<Users size={16} />} label="Factories" testId="admin-nav-factories" />
          <Item to="/admin/orders" icon={<ClipboardList size={16} />} label="Orders" testId="admin-nav-orders" />
          <Item to="/admin/ai-insights" icon={<Sparkles size={16} />} label="AI Insights" testId="admin-nav-ai" />
          <Item to="/admin/plans" icon={<Package size={16} />} label="Plans" testId="admin-nav-plans" />
        </nav>
        <Button variant="outline" onClick={() => { logout(); nav("/admin/login"); }}
          className="bg-transparent text-secondary-foreground border-white/20 hover:bg-white/10 hover:text-secondary-foreground"
          data-testid="admin-logout">
          <LogOut size={14} className="mr-2" /> Log out
        </Button>
      </aside>

      <main className="flex-1 p-6 md:p-10 max-w-6xl">{children}</main>
    </div>
  );
}

function Item({ to, icon, label, end, testId }) {
  return (
    <NavLink
      to={to}
      end={end}
      data-testid={testId}
      className={({ isActive }) =>
        `flex items-center gap-2 px-3 py-2.5 rounded-lg text-sm font-semibold transition-colors ${
          isActive ? "bg-primary text-primary-foreground" : "hover:bg-white/10"
        }`
      }
    >
      {icon}
      {label}
    </NavLink>
  );
}
